import React, { useState, useEffect } from "react";
import {
  createCustomer,
  updateCustomer,
} from "../../services/customer.service";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomField from "../common/customField";
import { toast } from "react-toastify";
import {
  optionsForPerferedCommunication,
  optionsForGender,
  optionsForAccountCategory,
  optionsForAgeGroup,
} from "../common/utlity/options";
import { Country, State } from "country-state-city";
import { getFingerprint } from "../../helpers/fingerprint";

import { initialValuesForCustomers } from "../common/utlity/intialValues";
import {
  onlyNumber,
  onlyNumberdesimal,
  onlyLetters,
} from "../../helpers/formats";
import { useParams } from "react-router-dom";
import CustomPhoneNumberField from "../common/customPhone";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import TourGuide from "../common/TourGuide";
import { CustomerSteps } from "../../lib/constants/TourSteps";
import {
  FiUser,FiArrowLeft
} from "react-icons/fi";

import { AiFillInfoCircle } from "react-icons/ai";
import { FaUniversity, FaMoneyBillWave } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getCustomersData } from "../../store/actions/action";

const AddCustomer = ({
  close,
  item,
  addCustomer,
  updateCustomerItem,
  businessUuid,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [selectedSection, setSelectedSection] = useState("Customer_Details");
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const { bussinessUuid: paramUuid } = useParams();
  const finalBusinessUuid = businessUuid || paramUuid;
  const customers = useSelector((state) => state?.customers?.customers);
  const [runTour, setRunTour] = useState(false);
  useEffect(() => {
    const waitForElements = () => {
      const allElementsExist = document.querySelector(
        ".bulk-upload-customer-tour"
      );
      //  document.querySelector(".transaction-status-tour");

      if (customers?.length === 0 && allElementsExist) {
        setRunTour(true);
      } else {
        setTimeout(waitForElements, 300);
      }
    };

    waitForElements();
  }, [customers]);
  useEffect(() => {
    const countryList = Country.getAllCountries().map((country) => ({
      label: country.name,
      value: country.isoCode,
    }));
    const stateList = State.getStatesOfCountry("IN").map((state) => ({
      label: state.name,
      value: state.isoCode,
    }));

    setStates(stateList);
    setCountries(countryList);
  }, []);
  const handleCountryChange = (setFieldValue, countryIsoCode) => {
    setFieldValue("country", countryIsoCode);
    const stateList = State.getStatesOfCountry(countryIsoCode || "IN").map(
      (state) => ({
        label: state.name,
        value: state.isoCode,
      })
    );
    setStates(stateList);
    setFieldValue("state", "");
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .matches(/^[a-zA-Z\s]+$/, "Name must contain only letters and spaces")
      .min(2, "Name must be at least 2 characters")
      .max(50, "Name must be at most 50 characters")
      .required(
        <span className='text-xs dark:text-red-500'>Name is required</span>
      ),

    customer_mobile: Yup.string()
      .min(10, "Number must be at least 10 digits")
      .max(15, "Number must be at most 10 digits"),

    // gstIN: Yup.string().matches(
    //   /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1})$/,
    //   "Invalid GSTIN"
    // ),
    // email: Yup.string().email("Invalid email"),

    pincode: Yup.string().test(
      "is-valid-pincode",
      <span className='text-xs dark:text-red-500'>
        Pincode must be between 5 and 10 digits
      </span>,
      (value) => /^[0-9]{5,10}$/.test(value)
    ),

    // customer_address: Yup.string()
    //   .min(5, "Address must be at least 5 characters")
    //   .max(100, "Address must be at most 100 characters"),
  });
  const onSubmit = async (values, { resetForm }) => {
    if (!finalBusinessUuid) {
      toast.error("Business UUID is missing");
      return;
    }

    const selectedDateOfBirth = new Date(values.dateOfBirth);
    const currentDate = new Date();

    if (selectedDateOfBirth > currentDate) {
      toast.error("Date of Birth cannot be a future date");
      return;
    }

    const fingerprint = await getFingerprint();
    const dataForSave = {
      ...values,
      bussinessUuid: finalBusinessUuid,
      fingerprint,
    };

    try {
      if (item) {
        const { customerId } = item;
        const result = await updateCustomer(
          finalBusinessUuid,
          customerId,
          dataForSave
        );

        if (result.status === 200) {
          updateCustomerItem(result?.data);
          close(true);
          toast.success("Updated Successfully ");
          await dispatch(
                      getCustomersData(finalBusinessUuid, {
                        page: 1,
                        limit: 10,
                        search: "",
                      }),
                    );
          navigate(-1)
        } else {
          throw new Error("Something Went wrong!");
        }
      } else {
        const result = await createCustomer(finalBusinessUuid, dataForSave);

        if (result.status === 201) {
          addCustomer(result?.data);
          resetForm();
          close();
          toast.success("Successfully Created");
          navigate(-1)
        } else if (result?.response?.status === 400) {
          throw new Error(result.response.data.message);
        } else {
          throw new Error(result?.data?.message || "Something Went wrong!");
        }
      }
    } catch (error) {
      toast.error(error.message);
      console.error("Error:", error);
    }
  };
  return (
    <>
      <TourGuide steps={CustomerSteps} runTour={runTour} />
      <Formik
        enableReinitialize={true}
        initialValues={initialValuesForCustomers(item ? item : null)}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => {
          const {
            errors,
            values,
            touched,
            handleBlur,
            handleChange,
            setFieldValue,
          } = formik;
          return (
            <Form>
              <div className="bg-white h-screen dark:bg-slate-900 border border-slate-200/80 dark:border-slate-700 shadow-lg shadow-slate-200/40 dark:shadow-black/20 p-8 transition-all duration-300">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="flex items-center justify-center w-11 h-11 mb-3 rounded-xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-slate-800 hover:bg-blue-50 dark:hover:bg-slate-700 transition-all shadow-sm"
              >
                <FiArrowLeft className="text-xl text-gray-700 dark:text-white" />
              </button>
                
                <div className="mt-1 p-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gradient-to-br dark:from-slate-900 dark:via-indigo-950 dark:to-slate-800 shadow-[0_0_15px_rgba(0,0,0,0.08)] dark:shadow-[0_0_20px_rgba(0,0,0,0.4)]">
  <div className="flex items-center gap-3 mb-3">
                    <div className=" rounded-full flex items-center justify-center">
                      <FiUser
    size={20}
    className="text-blue-600 dark:text-white"
  />
                    </div>
  
                    <h2 className="text-1xl font-semibold text-slate-800 dark:text-white">
                      {t('SALESIDEBAR.CUSTOMER_INFORMATION')}
                    </h2>
                  </div>
                      <div className="grid grid-cols-1 mt-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        <div>
                          <CustomField
                            type='text'
                            name='name'
                            label={t("FORM.NAME")}
                            placeholder='Name'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.name}
                            error={errors.name}
                            touched={touched.name}
                            onKeyPress={onlyLetters}
                          />
                        </div>
                        <div>
                          <CustomPhoneNumberField
                            name='customer_mobile'
                            country={values.countryCode}
                            label={t("FORM.PHONE")}
                            placeholder='Mobile'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.customer_mobile}
                            error={errors.customer_mobile}
                            touched={touched.customer_mobile}
                          />
                        </div>
                        <div>
                          <CustomField
                            type='text'
                            name='email'
                            label={t("SIDER.EMAIL")}
                            placeholder='Email'
                            value={values.email}
                            handleChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.email}
                            touched={touched.email}
                          />
                        </div>
                        <div className=''>
                          <CustomField
                            type='select'
                            name='perferedCommunication'
                            placeholder='Preferred communication'
                            label={t("SIDER.PREFERRED_COMMUNICATION")}
                            handleChange={handleChange}
                            value={values.perferedCommunication}
                            options={optionsForPerferedCommunication}
                            setFieldValue={setFieldValue}
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-1 mt-5 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        <div>
                          <CustomField
                            type='select'
                            name='country'
                            label={t("FORM.COUNTRY")}
                            options={countries}
                            setFieldValue={setFieldValue}
                            handleChange={(e) =>
                              handleCountryChange(
                                setFieldValue,
                                e?.target?.value
                              )
                            }
                            value={values.country}
                          />
                        </div>
                        <div>
                          <CustomField
                            type='select'
                            name='state'
                            label={t("FORM.SATAE")}
                            placeholder='State'
                            handleChange={(e) =>
                              setFieldValue("state", e?.target?.value)
                            }
                            options={states}
                            setFieldValue={setFieldValue}
                            value={values.state}
                          />
                        </div>
                        <div className='col-span-1'>
                          <CustomField
                            type='text'
                            name='customer_address'
                            label={t("FORM.ADDRESS")}
                            placeholder='Enter address'
                            handleChange={handleChange}
                            value={values.customer_address}
                          />
                        </div>
                        <div className='col-span-1'>
                          <CustomField
                            type='text'
                            name='pincode'
                            placeholder='Pincode'
                            label={t("SIDER.PINCODE")}
                            handleChange={handleChange}
                            value={values.pincode}
                            maxLength={10}
                            onKeyPress={onlyNumber}
                            error={errors.pincode}
                            touched={touched.pincode}
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-1 mt-5 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        <div>
                          <CustomField
                            type='text'
                            name='pan'
                            label={t("PROFILE.BUSINESS_PAN")}
                            placeholder='pan'
                            handleChange={handleChange}
                            value={values.pan}
                          />
                        </div>
                        <div>
                          <CustomField
                            type='text'
                            name='pendingAmount'
                            label={t("SIDER.PENDING_AMOUNT")}
                            placeholder='Pending Amount'
                            handleChange={handleChange}
                            value={values.pendingAmount}
                            onKeyPress={onlyNumberdesimal}
                          />
                        </div>
                        <div>
                          <CustomField
                            type='text'
                            name='advanceAmount'
                            label={t("SIDER.ADVANCE_AMOUNT")}
                            placeholder='Advance Amount'
                            handleChange={handleChange}
                            value={values.advanceAmount}
                            onKeyPress={onlyNumberdesimal}
                            disabled={parseFloat(values.pendingAmount) > 0}
                          />
                        </div>
                        <div>
                          <CustomField
                            type='text'
                            name='creditLimit'
                            label={t("FORM.CREDIT_LIMIT")}
                            placeholder='Credit Limit'
                            handleChange={handleChange}
                            value={values.creditLimit}
                            onKeyPress={onlyNumberdesimal}
                          />
                        </div>
                        <div>
                          <CustomField
                            type='date'
                            name='committedDateToPay'
                            label={t("SIDER.COMMITED_DATE_TOPAY")}
                            onChange={handleChange}
                            value={values.committedDateToPay}
                          />
                        </div>
                      </div>
                </div>
                  <div className="mt-3 p-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gradient-to-br dark:from-slate-900 dark:via-indigo-950 dark:to-slate-800 shadow-[0_0_15px_rgba(0,0,0,0.08)] dark:shadow-[0_0_20px_rgba(0,0,0,0.4)]">
   <div className="flex items-center gap-3 mb-3">
                    <div className=" rounded-full flex items-center justify-center">
                      <FaUniversity
    size={20}
    className="text-blue-600 dark:text-white"
  />
                    </div>
  
                    <h2 className="text-1xl font-semibold text-slate-800 dark:text-white">
                      {t("FORM.ADDITIONAL_INFORMATION")}
                    </h2>
                  </div>
                      <div className='space-y-2 '>

                          <div className="grid grid-cols-1 mt-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                            <div className='bg-white dark:bg-[#020617]'>
                              <CustomField
                                type='text'
                                name='occupation'
                                label={t("PROFILE.BUSINESS_OCCUPATION")}
                                placeholder='date Of Occupation'
                                handleChange={handleChange}
                                value={values.occupation}
                              />
                            </div>
                            <div className='bg-white dark:bg-[#020617]'>
                              <CustomField
                                type='date'
                                name='dateOfBirth'
                                label={t("SIDER.DATE_OF_BIRTH")}
                                placeholder='date of birth'
                                onChange={handleChange}
                                value={values.dateOfBirth}
                                error={
                                  new Date(values.dateOfBirth) > new Date()
                                    ? true
                                    : false
                                }
                                helperText={
                                  new Date(values.dateOfBirth) > new Date()
                                    ? "Future Date Not Allowed"
                                    : ""
                                }
                              />
                            </div>
                            <div className=' bg-white dark:bg-[#020617]'>
                              <CustomField
                                type='select'
                                name='ageGroup'
                                placeholder='Age Group'
                                label={t("FORM.AGE_GROUP")}
                                handleChange={handleChange}
                                value={values.ageGroup}
                                options={optionsForAgeGroup}
                                setFieldValue={setFieldValue}
                              />
                            </div>

                            <div className='bg-white dark:bg-[#020617]'>
                              <CustomField
                                type='select'
                                name='gender'
                                placeholder='Gender'
                                label={t("SIDER.GENDER")}
                                handleChange={handleChange}
                                value={values.gender}
                                options={optionsForGender}
                                setFieldValue={setFieldValue}
                              />
                            </div>
                          </div>

                          <div className="grid grid-cols-1 mt-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                            <div className='bg-white dark:bg-[#020617]'>
                              <CustomField
                                type='date'
                                name='anniversaryDate'
                                label='Aniverssary Date'
                                placeholder='date of birth'
                                onChange={handleChange}
                                value={values.anniversaryDate}
                              />
                            </div>
                            <div className='mt-1 bg-white dark:bg-[#020617]'>
                              <CustomField
                                type='text'
                                name='doingBusinessAs'
                                label={t("SIDER.DOING_BUSINESS_AS")}
                                placeholder='Business As '
                                handleChange={handleChange}
                                value={values.doingBusinessAs}
                              />
                            </div>
                            <div className='mt-1 bg-white dark:bg-[#020617]'>
                              <CustomField
                                type='text'
                                name='fullNameOfBusiness'
                                label={t("SIDER.FULL_NAME_OF_BUSINESS")}
                                placeholder='fullName Of Business'
                                handleChange={handleChange}
                                value={values.fullNameOfBusiness}
                              />
                            </div>
                            <div className='mt-1 bg-white dark:bg-[#020617]'>
                              <CustomField
                                type='text'
                                name='note'
                                label='Note'
                                placeholder='Note'
                                handleChange={handleChange}
                                value={values.note}
                              />
                            </div>
                          </div>

                      </div>
                    </div>

                  <div className="mt-3 p-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gradient-to-br dark:from-slate-900 dark:via-indigo-950 dark:to-slate-800 shadow-[0_0_15px_rgba(0,0,0,0.08)] dark:shadow-[0_0_20px_rgba(0,0,0,0.4)]">
  <div className="flex items-center gap-3 mb-3">
                    <div className=" rounded-full flex items-center justify-center">
                      <FaMoneyBillWave
    size={20}
    className="text-blue-600 dark:text-white"
  />
                    </div>
  
                    <h2 className="text-1xl font-semibold text-slate-800 dark:text-white">
                      {t('EXTRA.BANK_DETAILS')}
                    </h2>
                  </div>
                      <div className="grid grid-cols-1 mt-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                        <div>
                          <CustomField
                            type='text'
                            name='accountNumber'
                            label={t("SIDER.ACCOUNT_NUMBER")}
                            placeholder='Account Number'
                            handleChange={handleChange}
                            value={values.accountNumber}
                            onKeyPress={onlyNumber}
                          />
                        </div>
                        <div>
                          <CustomField
                            type='text'
                            name='ifscNumber'
                            label={t("PROFILE.BUSINESS_IFSC")}
                            placeholder='IFSC Number'
                            handleChange={handleChange}
                            value={values.ifscNumber}
                            maxLength={11}
                          />
                        </div>
                        <div className='mb-3 '>
                          <CustomField
                            type='select'
                            name='accountType'
                            label={t("PROFILE.BUSINESS_ACCOUNT_TYPE")}
                            handleChange={handleChange}
                            value={values.accountType}
                            options={optionsForAccountCategory}
                            setFieldValue={setFieldValue}
                          />
                        </div>
                      </div>
                    </div>


              <div className="flex justify-end gap-1 pr-4">
                {/* <div className=""> */}
                {/* <Link
                  to={`/${bussinessUuid}/dashboard/buddies/customers/bulkupload`}
                  type='button'
                  className='border border-blue-500 font-bold py-2 px-2 hover:bg- gray-100 mt-4 rounded rounded-lg text-center text-blue-500 w-1/2 bulk-upload-customer-tour '
                  // onClick={handleBulkUpload}
                >
                  {t("FORM.BULK_UPLOAD")}
                </Link> */}
                {/* </div> */}

                {item ? (
                  <button
                    type='submit'
                    className='w-1/2 py-2 px-2 bg-blue-600 hover:bg-blue-700 text-white mt-4 font-bold rounded justify-content-right'
                  >
                    {t("FORM.UPDATE_CUSTOMER")}
                  </button>
                ) : (
                  <button
                    type='submit'
                    className='w-1/2 py-2 px-2 bg-blue-600 hover:bg-blue-700 text-white  mt-4 font-bold rounded justify-content-right'
                  >
                    {t("COMMON.ADD_CUSTOMER")}
                  </button>
                )}
              </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default AddCustomer;
